import React from 'react';

import VpDeleteDialog from '../VpDeleteDialog/VpDeleteDialog';
import { useDeletePlugin, usePluginsContext } from '../../../hooks';

export const VpDeletePluginDialog = () => {
  const { selectedPluginId, setSelectedPluginId } = usePluginsContext();
  const { mutate, isLoading } = useDeletePlugin();

  const onClose = () => {
    setSelectedPluginId(null);
  };
  const onDelete = () => {
    mutate(selectedPluginId);
  };

  return (
    <VpDeleteDialog
      shouldCloseOnDelete
      loading={isLoading}
      open={!!selectedPluginId}
      type="Plugin"
      onClose={onClose}
      onDelete={onDelete}
    />
  );
};

export default VpDeletePluginDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpDeletePluginDialog/VpDeletePluginDialog.jsx